<template>
    <div v-if="accounts.length > 1 || (accounts.length == 1 && accounts[0].SmartBizClientId !== $store.state.user.SmartBizClientId)" class="card mb-4">
        <div class="card-header">
            <strong>Alternative Logins ({{ accounts.length }})</strong>

            <button class="btn btn-sm btn-light btn-toggle" v-on:click="showLogins = !showLogins" :title="(showLogins ? 'Hide' : 'Show') + ' Alternative Logins'">
                <i :class="'fa fa-caret-' + (showLogins ? 'up' : 'down')"></i>
            </button>
        </div>
        <div :class="{'card-body': true, 'd-none': !showLogins}" style="overflow-x: auto; white-space: nowrap">
            <div v-for="account in accounts" class="d-inline-block py-2 px-2" style="width: 270px; padding: 0 10px; margin-right: 10px; border: 1px solid rgba(24, 28, 33, 0.06); vertical-align: top">
                <div class="row mb-2">
                    <div class="col-md-5 mb-sm-0 mb-1">
                        <img :src="account.brand_logo_large" class="img-fluid" />
                    </div>
                    <div class="col-md-7">
                        <small v-if="account.SmartBizClientId === $store.state.user.SmartBizClientId"><i>Currently Logged In</i></small>
                        <button v-else @click="login(account.SmartBizClientId)" class="btn btn-sm btn-secondary" :title="'One-Click Log into '+ account.ClientName">Login&nbsp;<i class="fa fa-sign-in"></i></button>
                    </div>
                </div>
                <p><strong class="notranslate">{{ account.ClientName }}</strong></p>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        data: function() {
            return {
                accounts: [],
                intended: this.$route.query ? this.$route.query.intended : null,
                subdomain: window.location.hostname.split('.')[0],
                showLogins: false,
            }
        },

        methods: {
            getAltAccounts: function() {
                //Get the data
                this.$http
                    .get('profile/alt-accounts')
                    .then(response => {
                        //Set all the data
                        this.accounts = response.data

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            login: function(SmartBizClientId) {
                this.$http.postWeb(`alt-account-login/${SmartBizClientId}`).then(() => {
                    if (this.intended)
                    {
                        window.location = (this.intended.replace(/_/gi, '/'));
                    }
                    else
                    {
                        window.location = '/';
                    }
                });
            }
        },

        mounted() {
            this.getAltAccounts();
        },
    }
</script>
